/**
 * 成都学生的文案特殊处理，不能出现申请或者申请人字样
*/
export default {
    // 英国国王学院学校中国第三合作校狄邦肯思学校
    kcscd: {
        file1: 'file1Tmp',
        file1Tip: 'file1TipTmp',
        file3: 'file3Tmp',
        file4Tip: 'file4TipTmp',
        applicationEnterYear: 'applicationEnterYearTmp',
        applicationSchool: 'applicationSchoolTmp',
        applicationGrade: 'applicationGradeTmp',
        tip3: 'tip3Tmp',
        tip4: 'tip4Tmp',
        hobbyTip: 'hobbyTipTmp',
        achievementTip: 'achievementTipTmp',
        applicationConfirmation: 'applicationConfirmationTmp',
        hasDraftTip: 'hasDraftTipTmp',
        unsubmittedTip: 'unsubmittedTipTmp',
        applyOnline: 'applyOnline',
        confirmSubmit: 'confirmSubmitTmp',
        confirmSubmitTip: 'confirmSubmitTipTmp',
    },
    default: {
        file1: 'file1',
        file1Tip: 'file1Tip',
        file3: 'file3',
        file4Tip: 'file4Tip',
        applicationEnterYear: 'applicationEnterYear',
        applicationSchool: 'applicationSchool',
        applicationGrade: 'applicationGrade',
        tip3: 'tip3',
        tip4: 'tip4',
        hobbyTip: 'hobbyTip',
        achievementTip: 'achievementTip',
        applicationConfirmation: 'applicationConfirmation',
        hasDraftTip: 'hasDraftTip',
        unsubmittedTip: 'unsubmittedTip',
        applyOnline: 'applyOnline',
        confirmSubmit: 'confirmSubmit',
        confirmSubmitTip: 'confirmSubmitTip',
    }
}